import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { Application } from 'src/app/account/services/application.service'
import { MalwareScanIssue, SyncPairPermissionIssue } from 'src/app/account/services/issue'
import { SyncPair } from 'src/app/account/services/sync-pair.service'
import { UiService } from 'src/app/services/ui.service'
import { environment } from 'src/environments/environment'

@Component({
  selector: 'malware-scan-issue',
  templateUrl: './malware-scan-issue.component.html',
  styleUrls: ['./malware-scan-issue.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MalwareScanIssueComponent implements OnInit {
  @Input() issue: MalwareScanIssue = null
  @Input('sync-pair') syncPair: SyncPair = null
  @Input('application') application: Application = null

  private _manualResourceTemplate: string = null

  constructor(public uiService: UiService) {}

  ngOnInit() {
    let manualResourceTemplateUrl$ = !!this.syncPair
      ? this.syncPair.manualResourceTemplateUrl$
      : this.application.manualResourceTemplateUrl$
    manualResourceTemplateUrl$.subscribe((template) => (this._manualResourceTemplate = template))
  }

  get sourceRegion() {
    return !!this.syncPair ? this.syncPair.sourceRegion : this.application.sourceRegion
  }

  get sourceAwsAccountId() {
    return !!this.syncPair ? this.syncPair.sourceAwsAccountId : this.application.sourceAwsAccountId
  }

  get targetRegion() {
    return !!this.syncPair ? this.syncPair.targetRegion : this.application.targetRegion
  }

  get targetAwsAccountId() {
    return !!this.syncPair ? this.syncPair.targetAwsAccountId : this.application.targetAwsAccountId
  }

  get productName() {
    return environment.productName
  }
}
